// @index('./*', pp => `export * from '${pp.path}';`)
export * from './result';
